import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventMessage } from 'entities/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type CallHistoryStore } from 'pages/conversations/pages/calls/ui/CallHistory'

export const useEventVoicemailReceived = (callHistoryStore: CallHistoryStore) => {
  const { inboxesStore, websocket } = useEntitiesContext()
  const handler = (data: IResponseEventMessage) => {
    const { call_history, conversation } = data
    if (!call_history || inboxesStore.currentInboxTypeId !== conversation.inbox_id) return

    const { type, outcome } = call_history.call

    if (type && outcome) {
      callHistoryStore.updateCallHistoryByVoicemailEvent(call_history)
    }
  }

  useEffect(() => websocket.on(WebsocketEvent.VoicemailReceived, handler), [])
}
